import * as _ from "lodash";
import { assert } from "./assert";

export const disposerTree = (name: string, parent?: DisposerTree) => {
  const level = parent ? parent.level + 1 : 0;

  const leaf: DisposerTree = {
    level,
    name,
    children: [],
    disposers: [],
    get isDisposed() {
      return !leaf.children && !leaf.disposers;
    },
    dispose: () => {
      assert(!leaf.isDisposed, `leaf is not disposed twice (${name})`);

      for (let i = leaf.children.length - 1; i >= 0; i--) {
        const child = leaf.children[i];
        child.dispose();
      }

      leaf.children = null;

      leaf.disposers.forEach((d) => d());
      leaf.disposers = null;

      if (parent) {
        assert(
          !parent.isDisposed,
          `parent is not disposed before child (${name})`
        );

        _.remove(parent.children, (c) => c === leaf);
      }
    },
  };

  if (parent) parent.children.push(leaf);

  return leaf;
};

export type Disposer = () => any;
export type Disposers = Disposer[];

/** Tree structure of disposer functions. Useful for calling all disposer functions in a subtree. */
export interface DisposerTree {
  name: string;
  level: number;
  children: DisposerTree[];
  disposers: Disposers;
  dispose: () => void;
  readonly isDisposed: boolean;
}
